import React, { useState, useEffect } from "react";
import { Link as ScrollLink } from "react-scroll";
import navbarContent from "../content/navbar.json";
import threedots from "../assets/threedots.svg";
import closeIcon from "../assets/closeIcon.svg";
import logo from "../assets/logo_main.svg";
import "../styles/Navbar.css";

const MOBILE_BREAKPOINT = 1000;

const Navbar = ({ language, setLanguage, activeItem, setActiveItem }) => {
  const [content, setContent] = useState(navbarContent.en);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setContent(navbarContent[language] || navbarContent.en);
  }, [language]);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    const handle = (e) => setIsMobile(e.matches);
    handle(mq);
    mq.addEventListener("change", handle);
    return () => mq.removeEventListener("change", handle);
  }, []);

  useEffect(() => {
    if (!isMobile && menuOpen) setMenuOpen(false);
  }, [isMobile, menuOpen]);

  return (
    <>
      <nav className={`navbar ${isMobile ? "mobile-navbar" : "desktop-navbar"}`}>
        <div className="container">
          {/* LEFT: Logo */}
          <Logo setActiveItem={setActiveItem} />

          {/* CENTER: Nav (desktop only) */}
          {!isMobile ? (
            <DesktopNavbar
              content={content}
              activeItem={activeItem}
              setActiveItem={setActiveItem}
              language={language}
            />
          ) : (
            <div className="center-spacer" />
          )}

          {/* RIGHT: Controls */}
          {!isMobile ? (
            <div className="right-controls">
              {/* <LoginLink variant="desktop" /> */}
              {/* Language selector hidden for now */}
            </div>
          ) : (
            <div className="mobile-right">
              <button
                className={`menu-icon ${menuOpen ? "menu-icon-open" : ""}`}
                onClick={() => setMenuOpen((v) => !v)}
                aria-label="Toggle menu"
                aria-expanded={menuOpen}
              >
                <img
                  src={menuOpen ? closeIcon : threedots}
                  alt="Menu"
                  className="icon-image"
                />
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* MOBILE OVERLAY MENU */}
      {isMobile && (
        <div
          className={`overlay ${menuOpen ? "overlay-open" : "overlay-closed"}`}
          onClick={(e) => {
            if (e.target.classList.contains("overlay")) setMenuOpen(false);
          }}
        >
          <div className="overlay-panel" role="dialog" aria-modal="true">
            <ul
              className="nav-links-open"
              style={{ textAlign: language === "ar" ? "right" : "left" }}
            >
              {Object.keys(content.navItems).map((key) => (
                <li key={key} className="nav-item">
                  <ScrollLink
                    to={key}
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className={`link-mobile ${
                      language === "ar" ? "arabic-text" : ""
                    }`}
                    onSetActive={() => setActiveItem(key)}
                    onClick={() => setMenuOpen(false)}
                  >
                    {content.navItems[key]}
                  </ScrollLink>
                </li>
              ))}

              {/* Login inside the mobile menu */}
              <li className="nav-item login-item-mobile">
                {/* <LoginLink variant="mobile" onClick={() => setMenuOpen(false)} /> */}
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

const Logo = ({ setActiveItem }) => (
  <div className="logo-container">
    <ScrollLink
      to="home"
      smooth={true}
      duration={500}
      offset={-100}
      className="logo-link"
      onSetActive={() => setActiveItem("home")}
    >
      <img src={logo} alt="Logo" className="logo-image" />
    </ScrollLink>
  </div>
);

// const LoginLink = ({ variant = "desktop", onClick }) => (
//   <a
//     href="https://my.xpeditesolutions.com"
//     className={`login-link ${variant === "mobile" ? "login-link-mobile" : "login-link-desktop"}`}
//     onClick={onClick}
//   >
//     Login
//   </a>
// );

const DesktopNavbar = ({ content, activeItem, setActiveItem, language }) => {
  const navKeys = Object.keys(content.navItems);
  const ordered = content.navOrder?.length
    ? [...navKeys].sort((a, b) => content.navOrder.indexOf(a) - content.navOrder.indexOf(b))
    : navKeys;

  const displayedNavItems = language === "ar" ? ordered.reverse() : ordered;

  return (
    <ul className="nav-links">
      {displayedNavItems.map((key) => (
        <li key={key} className="nav-item">
          <ScrollLink
            to={key}
            smooth={true}
            duration={500}
            offset={-100}
            className={`link desktop-nav-item ${
              activeItem === key ? "active-link" : ""
            } ${language === "ar" ? "arabic-text" : ""}`}
            onSetActive={() => setActiveItem(key)}
          >
            {content.navItems[key]}
          </ScrollLink>
        </li>
      ))}
    </ul>
  );
};

export default Navbar;
